import React, { useState, useEffect } from 'react';
import './cookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => {
        setVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    // Ensure we do not use cookies: remove any optional cookies/storage if any were set
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-bar">
      <div className="cookie-consent-content">
        <p>
          We use cookies to improve your browsing experience, show personalized content, and analyze site traffic.
          By clicking <strong>"Accept"</strong>, you consent to our use of cookies.
        </p>
        <div className="cookie-consent-buttons">
          <button className="btn sm cookie-decline" onClick={handleDecline}>Decline</button>
          <button className="btn sm primary cookie-accept" onClick={handleAccept}>Accept</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
